<template>
  <div
    class="category-goods-div"
    v-if="categoryGoods && categoryGoods.length > 0"
  >
    <!-- 商品分类名称 -->
    <div class="spanclass">
      <span>{{ constant.tsname }}</span>
    </div>
    <!--分类商品展示-->
    <div class="category-goods-show">
      <div
        class="category-goods-container"
        v-for="(cg, i) in categoryGoods"
        :key="i"
        :style="
          (i + 1) % 3 == 0 ? { marginRight: '0px' } : { marginRight: '10px' }
        "
      >
        <div class="category-name">
          <!-- 分类名称 -->
          <a href="javascript:void(0)" @click="searchByCat(cg.category)">
            <span>{{ cg.category.name }}</span>
          </a>
          <!-- 更多 -->
          <a href="javascript:void(0)" @click="searchByCat(cg.category)">
            {{ constant.more }}
            <img class="imgmore" src="img/more.png" />
          </a>
        </div>
        <!-- 商品 -->
        <div class="goods">
          <div class="good" v-for="(good, index) in cg.goods" :key="index">
            <a href="javascript:void(0)" @click="jumpToDetail(good)">
              <img :src="good.productImgPath" />
            </a>
            <div class="msg">
              <a
                @click="jumpToDetail(good)"
                href="javascript:void(0)"
                style="text-decoration: none; color: black"
              >
                <div class="name" :title="good.productName">
                  {{ good.productName }}
                </div>
              </a>
              <div class="supplier">{{ good.supplier }}</div>
              <div class="price">
                {{ constant.currencySymbol }}{{ good.shopPrice }}
                <!-- 加入购物车 -->
                <a
                  class="addcart"
                  :key="index"
                  @click="addToCart(good)"
                >
                  <img src="img/ncart.png" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    let categoryGoodsShow = this.$store.state.malMainPageConfig
      .categoryGoodsShow;
    return {
      constant: this.$store.state.malMainPageConfig.constant,
    };
  },
  computed: {
    categoryGoods: function () {
      return this.$store.state.malMainPageConfig.categoryGoodsShow
        .categoryGoods;
    },
  },
  methods: {
    // 添加到购物车
    addToCart(item) {
      this.$api.mainpageApi
        .addToCart(item.productId, item.source)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit({
              type: "updateCartNum",
              currentNum: response.data.data,
            });
            this.$message({
              showClose: true,
              message:
                item.productName +
                this.$store.state.malMainPageConfig.constant.addToCartSuccess,
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message:
                item.productName +
                this.$store.state.malMainPageConfig.constant.addToCartFail,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message:
              item.productName +
              this.$store.state.malMainPageConfig.constant.addToCartFail,
            type: "error",
          });
        });
    },
    jumpToDetail(product) {
      // 进去新版商品详情
      let param = "";
      if (product.source == "1") {
        param = "&productSelfId=" + product.productId;
      } else {
        param =
          "&productJdSku=" +
          product.productnumber +
          "&productsource=" +
          product.source;
      }
      let url = axios.defaults.baseURL + "/index.html?formId=mal_newproductdetail" + param;
      window.open(url, "_blank");
    },
    searchByCat(navItem) {
      //如果是一二级分类，取值为当前编码
      var searchFields=encodeURIComponent(navItem.number);
      var navlevel=navItem.level;
      //如果是三级分类，取值为长编码
      if(navlevel=='3'){
        searchFields=encodeURIComponent(navItem.longNumber);
      }
      // 通过商品来源过滤 参数 source longnumber name
      let url = 
          axios.defaults.baseURL +
          "/index.html#/dform?formId=mal_newsearch&source=" +
          navItem.source +
          "&searchText=" +
          navItem.name +
          "&level=" +
          navlevel +
          "&searchFields=" +
          searchFields;
      
      window.open(url, "_blank");
    },
  },
};
</script>

<style  lang="scss">
a{
  cursor: pointer;
}
.category-goods-div {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
  background-color: #f5f5f5;
}
.spanclass {
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 24px;
  color: #333333;
  margin-top: 40px;
  float: left;
}
.category-goods-show {
  width: 1200px;
  min-height: 450px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.category-goods-container {
  width: 393px;
  height: 553px;
  background: white;
  margin-right: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 24px;
}
.category-name {
  height: 76px;
  display: flex;
  justify-content: space-between;
  padding: 0 30px 0 30px;
  align-items: center;
  color: #666666;
}
.category-name span {
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 18px;
  color: #333333;
  line-height: 16px;
  font-weight: 550;
}
.category-name a {
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: #666666;
  text-decoration: none;
}
.goods {
  height: 460px;
  padding: 0 30px 0 30px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
}
.goods .good {
  height: 100px;
  margin-bottom: 15px;
  display: flex;
  justify-content: flex-start;
  flex-shrink: 0;
  flex-grow: 0;
}
.good img {
  width: 100px;
  height: 100px;
}
.good .msg {
  height: 100px;
  width: 215px;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}
.good .msg .name {
  height: 36px;
  line-height: 20px;
  overflow: hidden;
  margin-bottom: 10px;
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.good .msg a :hover {
  color: #2386ee;
}
.good .msg .supplier {
  height: 18px;
  line-height: 18px;
  overflow: hidden;
  margin-bottom: 10px;
  // 苹方-简 常规体
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.good .msg .price {
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 20px;
  color: #ed542b;
  letter-spacing: 0;
  line-height: 20px;
}
.addcart {
  width: 18px;
  height: 18px;
}
.good .addcart img {
  height: 18px;
  width: 18px;
  float: right;
}
.imgmore {
  vertical-align: middle;
  margin-top: -2px;
}
</style>
